/* Ask the Pack: the loader (28 October 2026). The panel's own script is nocry-ask-panel.js (53 KB, 19 KB on the wire), and
   it loads when it is wanted, not with every page: on the first tap, hover or focus on a launcher (the wolf, any
   data-ask-open link), at once on a page reached back from a sent message (the pending message in sessionStorage, the marks
   in the address, the challenge page as the referrer), and otherwise once the page has loaded and the browser is idle, so a
   visitor who opens it later finds it ready. Until it has loaded, a tap on a launcher is held and replayed once it has.
   NOCRY.ask (the chat fallback in nocry-global.js) loads it the same way. sections/ask-the-pack.liquid loads this file as it
   always did; layout/theme.liquid hands it the panel script's address (NOCRY.askSrc, with the asset's version), with this
   file's own address as the fallback. */
const src = (window.NOCRY && window.NOCRY.askSrc) || import.meta.url.replace(/nocry-ask\.js(\?[^#]*)?$/, 'nocry-ask-panel.js$1');
let loading = null, ready = false;
function load() {
  if (!loading) loading = import(src).then(() => { ready = true; }, () => { loading = null; });
  return loading;
}
const stub = {
  open: () => load().then(() => { if (window.NOCRY.ask !== stub) window.NOCRY.ask.open(); }),
  person: () => load().then(() => { if (window.NOCRY.ask !== stub) window.NOCRY.ask.person(); }),
  close: () => {},
};
window.NOCRY = Object.assign(window.NOCRY || {}, { ask: stub, askLoader: load });
document.addEventListener('click', (e) => {
  if (ready) return;
  const el = e.target.closest && e.target.closest('[data-ask-open]'); if (!el) return;
  e.preventDefault();
  load().then(() => { if (ready) el.click(); });
}, true);
['pointerover', 'touchstart', 'focusin'].forEach((ev) => {
  document.addEventListener(ev, (e) => { if (!ready && e.target.closest && e.target.closest('[data-ask-open]')) load(); }, { capture: true, passive: true });
});
let back = false;
try { back = /[?&](ask_sent=1|contact_posted=true)\b/.test(location.search) || !!sessionStorage.getItem('nocry-ask-pending') || /\/challenge/.test(document.referrer || ''); } catch (e) { back = false; }
if (back) load();
else {
  const idle = () => (window.requestIdleCallback || ((f) => setTimeout(f, 2000)))(() => { load(); }, { timeout: 6000 });
  if (document.readyState === 'complete') idle(); else addEventListener('load', idle, { once: true });
}
